// 李丁
import request from '@/utils/request'
// 导出下载
export function downloadFileofurl(urls, name) {
  if (!urls) return
  return request({
    url: urls,
    method: 'get',
    headers: {
      "Access-Control-Allow-Origin": "*"
    },
    responseType: 'blob',
  }).then(res => {
    const url = window.URL.createObjectURL(new Blob([res]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  })

}

